// extracted by mini-css-extract-plugin
export var progressContainer = "_bg-0";